module.exports = __webpack_public_path__ + "static/media/map.fb9fd08e.svg";